export default __webpack_public_path__ + "static/EA_Library-3f537100ad041e47ba615a7887a91efb.gif";